import { sendSumoLog } from './sumoLogger';
import { v4 as uuidv4 } from 'uuid';

export const fetchTicketDocs = async (IDs, token, dispatch, loggingContext = '') => {
  // Validate IDs parameter - allow null/undefined/empty arrays to pass through for edge cases
  if (IDs && !Array.isArray(IDs)) {
    console.log('[fetchTicketDocs] ERROR: IDs is not an array', {
      IDs,
      type: typeof IDs,
      loggingContext,
    });
    return { rows: [] };
  }

  // Log parameters
  console.log('[fetchTicketDocs] Valid parameters received', {
    IDsCount: Array.isArray(IDs) ? IDs.length : 'N/A',
    IDs,
    hasToken: !!token,
    loggingContext,
  });

  try {
    const headers = new Headers({
      Authorization: `Bearer ${token}`,
    });
    let ticketDocsEndpoint = encodeURI(
      `${process.env.REACT_APP_COUCHBASE_URL}/lmark/_all_docs?include_docs=true`
    );

    const allDocsPostBody = { keys: IDs };
    headers.append('x-csrf-token', uuidv4());
    headers.append('content-type', 'application/json;');

    const docsResponse = await fetch(ticketDocsEndpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify(allDocsPostBody),
    });
    const docs = await docsResponse.json();

    console.log('[fetchTicketDocs] Returning result', {
      status: docsResponse.status,
      statusText: docsResponse.statusText,
      documents: docs,
      rowsCount: docs?.rows?.length || 0,
      totalRows: docs?.total_rows,
      offset: docs?.offset,
      loggingContext,
    });

    return docs;
  } catch (error) {
    const message = `fetch Ticket Docs call failed`;
    console.log('[fetchTicketDocs] ERROR: Exception caught', {
      error: error.message || error,
      stack: error.stack,
      loggingContext,
    });
    sendSumoLog(error, message, dispatch);
    return message;
  }
};
